import styled from 'styled-components';
 
interface StyledLoadingDotProps {
  $animationDelay: string;
}

const StyledLoadingDot = styled.div<StyledLoadingDotProps>`
  height: 5px;
  width: 5px;
  background-color: #000;
  border-radius: 50%;
  animation: bounce 0.8s ease-in-out infinite;
  animation-delay: ${(props) => props.$animationDelay ? props.$animationDelay : '0s'};

  @keyframes bounce {
    0% {
      translate: 0 -8px;
    }

    50% {
      translate: 0 0;
    }
    
    100% {
      translate: 0 -8px;
    }
  }
`;

export default StyledLoadingDot;